module.exports = __webpack_public_path__ + "static/media/habib.d81962c4.svg";